<template>
  <div class="balance-container">
    <BalanceWithdrawRecharge />
    <BalanceTransDetails />
  </div>
</template>

<script>
export default {
  name: 'Data_Balance',
  components: {
    BalanceWithdrawRecharge: () => import('./components/Balance/BalanceWithdrawRecharge.vue'),
    BalanceTransDetails: () => import('./components/Balance/BalanceTransDetails.vue')
  }
}
</script>

<style scoped>
.balance-container{

}
</style>
